import { Controls, FieldDirection } from '../ControlsPanel';

export type GroupSize = 'full' | 'half';

type ControlsGroup = {
  flow: FieldDirection;
  size: GroupSize;
  subtitle: string;
  controls: Controls[];
};

const controlGroupsData: ControlsGroup[] = [
  {
    subtitle: 'Customize player color',
    flow: 'horizontal',
    size: 'full',
    controls: [
      {
        id: 'playerColor',
        type: 'color'
      }
    ]
  },
  {
    subtitle: 'Playback settings',
    flow: 'vertical',
    size: 'half',
    controls: [
      {
        id: 'autoplay',
        type: 'checkbox',
        label: 'Autoplay'
      },
      {
        id: 'muted',
        type: 'checkbox',
        label: 'Mute'
      },
      {
        id: 'hideUnmute',
        type: 'checkbox',
        label: 'Hide Tap to Unmute'
      },
      {
        id: 'playHidden',
        type: 'checkbox',
        label: 'Keep playing when scrolled out'
      }
    ]
  },
  {
    subtitle: 'When video ends',
    flow: 'vertical',
    size: 'half',
    controls: [
      {
        id: 'end',
        type: 'select',
        values: [
          {
            value: 'showThumbnail',
            label: 'Show thumbnail'
          },
          {
            value: 'showLastFrame',
            label: 'Show last frame'
          },
          {
            value: 'loop',
            label: 'Loop'
          }
        ]
      }
    ]
  },
  {
    subtitle: 'Show controls',
    flow: 'vertical',
    size: 'full',
    controls: [
      {
        id: 'bigPlayButton',
        type: 'checkbox',
        label: 'Big play button'
      },
      {
        id: 'playbarButton',
        type: 'checkbox',
        label: 'Playbar'
      },
      {
        id: 'smallPlayButton',
        type: 'checkbox',
        label: 'Small play button'
      },
      {
        id: 'currentTime',
        type: 'checkbox',
        label: 'Current time'
      },
      {
        id: 'quality',
        type: 'checkbox',
        label: 'Quality'
      },
      {
        id: 'volume',
        type: 'checkbox',
        label: 'Volume'
      },
      {
        id: 'speed',
        type: 'checkbox',
        label: 'Speed'
      },
      {
        id: 'fullScreen',
        type: 'checkbox',
        label: 'Fullscreen'
      },
      {
        id: 'download',
        type: 'checkbox',
        label: 'Download button'
      },
      {
        id: 'logo',
        type: 'checkbox',
        label: 'Wave.video logo'
      }
    ]
  }
];

export default controlGroupsData;
